import fp from 'lodash/fp';
import { contentStatus } from '../../../constants';
import { cpdDaysRemaining, cpdWeeksRemaining, industryCpdDate } from '../../../services';

// Currently 1 user can only be associated with 1 business.
export const businessSelector = fp.flow(
  fp.get('business.businesses'),
  fp.head,
  fp.get('business')
);
export const businessTrainingPlanSelector = fp.flow(
  fp.get('business.businesses'),
  fp.head,
  fp.get('trainingPlans')
);
export const teamMembersSelector = fp.get('business.teamMembers');
export const queryTeamMembersSelector = fp.get('business.queryTeamMembers');
export const unassignedTeamMembersSelector = fp.get('business.unassignedTeamMembers');
export const businessTeamsSelector = fp.get('business.teams');
export const inactiveUserCpdActivitySelector = fp.get('business.inactiveUserCpdActivity');
export const isFetchingInactiveCpdActivitiesSelector = fp.get('business.isFetchingInactiveCpdActivities')
export const businessTeamsWithStatsSelector = fp.get('business.teamsWithStats');
export const businessTeamsWithProgressSelector = fp.get('business.teamsWithProgress')
export const businessCurrentTeamSelector = fp.get('business.team.currentTeam');
export const businessCurrentTeamStatsSelector = fp.get('business.team.currentTeamStats');
export const businessCurrentTeamMembersSelector = fp.get('business.team.currentTeamMembers');
export const businessCurrentTeamNonMemberManagersSelector = fp.get('business.team.currentTeamNonMemberManagers');
export const currentTeamMembersSelector = fp.get('business.team.currentTeam.members');
export const externalCpdForReviewSelector = fp.get('business.externalCpdForReview.externalCpd');
export const isFetchingExternalCpdForReviewSelector = fp.get('business.isFetchingExternalCpdForReview');
export const fullTeamCpdCategorysSelector = fp.get('business.teamCpdCategorys');
export const fullTeamPendingExternalCpdSelector = fp.get('business.teamPendingExternalCpd');
export const specificTeamPendingExternalCpdSelector = fp.get('business.specificTeamPendingExternalCpd');
export const teamCpdCategorysSelector = fp.get('business.team.cpdCategorys');
export const teamPendingExternalCpdSelector = fp.get('business.team.pendingExternalCpd');
export const invitationsSelector = fp.get('business.invitations');
export const businessIndustryRoles = fp.get('business.industryRoles');
export const businessMainIndustryRole = fp.flow(businessIndustryRoles, fp.first);
export const businessCpdDate = fp.flow(businessMainIndustryRole, industryCpdDate);
export const businessCpdDaysRemaining = fp.flow(businessCpdDate, cpdDaysRemaining);
export const businessCpdWeeksRemaining = fp.flow(businessCpdDate, cpdWeeksRemaining);
export const businessCpdCategorySelector = fp.get('business.businessCpdCategorys');
export const userCpdDaysRemaining = fp.flow(industryCpdDate, cpdDaysRemaining);
export const publicNonCpdContentSelector = fp.flow(
  fp.get('business.content.nonCpdContent'),
  fp.filter(
    ({ status }) => status !== contentStatus.Archived.value
  )
)
export const publicBusinessContentSelector = fp.flow(
  fp.get('business.content.contentResult.content'),
  fp.filter(
    ({ status }) => status !== contentStatus.Archived.value
  )
)


// WEBPACK FOOTER //
// ./src/state/modules/business/selectors.js